<div class="row m-0">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} empleado
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <ng-container *ngIf="service_alert.show">
      <div class="alert alert-{{service_alert.class}} alert-dismissible fade show" role="alert">
        <button type="button" class="close" aria-label="Close" (click)="service_alert.show = false">
          <span aria-hidden="true">×</span>
        </button>
        <strong>¡Datos extraídos!, </strong> {{service_alert.message}}
      </div>
    </ng-container>
    <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-lg-9">
          <div class="row">
            <div class="form-group col-lg-4">
              <label>Puesto de trabajo <span class="required"></span></label>
              <ng-container *ngIf="jobs.length > 0">
                <select id="jobSelected" class="form-control" formControlName="companyjob_id">
                  <ng-container *ngIf="!isEdit">
                    <option value="null">Seleccionar puesto</option>
                  </ng-container>
                  <option *ngFor="let item of jobs" [value]="item.id">{{ item.description }}</option>
                </select>
              </ng-container>
              <ng-container *ngIf="jobs.length == 0">
                <p class="m-b-5 f-s-9">No se encontraron registros</p>
              </ng-container>
            </div>
            <div class="form-group col-lg-4">
              <label>Tipo documento<span class="required"></span></label>
              <select class="form-control" formControlName="typedocument_id" id="typedocument_id">
                <option *ngFor="let item of typesdocument" [value]="item.id">{{ item.description }}</option>
              </select>
            </div>
            <div class="form-group col-lg-4">
              <label>N° Documento<span class="required"></span></label>
              <div class="input-group">
                <input type="text" id="client_document" class="form-control" formControlName="document" numeric required
                  autofocus maxlength="8">
                <div class="input-group-append bg-custom">
                  <div class="input-group-append bg-custom">
                    <div class="input-group-text pointer btn-reniec" (click)="extractDni()" data-toggle="tooltip"
                      data-placement="right" data-original-title="Extraer de Reniec"></div>
                  </div>
                </div>
              </div>
              <div *ngIf="submitted && f['document'].errors">
                <small class="text-danger" *ngIf="f['document'].errors['required']">Campo requerido</small>
              </div>
            </div>
            <div class="form-group col-lg-12">
              <label>Nombres completos <span class="required"></span></label>
              <input type="text" id="fullname" class="form-control" formControlName="fullname">
            </div>
            <div class="form-group col-lg-12">
              <label>Dirección</label>
              <textarea ng-model="client.address" rows="1" class="form-control no-resize"></textarea>
            </div>
            <div class="form-group col-lg-4">
              <label>Celular</label>
              <input type="text" class="form-control" formControlName="cellphone">
            </div>
            <div class="form-group col-lg-4">
              <label>Teléfono fijo</label>
              <input type="text" class="form-control" formControlName="telephone">
            </div>
            <div class="form-group col-lg-4">
              <label>Correo electrónico</label>
              <input type="email" class="form-control" formControlName="email">
            </div>
            <div class="form-group col-lg-4">
              <label>Fecha nacimiento</label>
              <input type="date" id="date_birthday" class="form-control" placeholder="yy-mm-dd"
                formControlName="date_birthday">
            </div>
            <div class="form-group col-lg-4">
              <label>Estado civil</label>
              <select class="form-control" id="statusSelected" formControlName="status">
                <option *ngFor="let item of statusmarital" [value]="item.id">{{ item.description }}</option>
              </select>
            </div>
            <div class="form-group col-lg-4">
              <label>Sexo</label>
              <select class="form-control" id="sexSelected" formControlName="sex">
                <option *ngFor="let item of sexs" [value]="item.id">{{ item.description }}</option>
              </select>
            </div>

            <!-- asignar oficina al empleado -->
            <div class="col-lg-12 m-t-10">
              <p class="form__group__title">Asignar Oficina/Local <span class="required"></span></p>
              <div class="row">
                <ng-container *ngFor="let item of branchoffices">
                  <div class="col-lg-4">
                    <div class="custom-control custom-checkbox m-t-5">
                      <input type="checkbox" class="custom-control-input" id="branch_{{item.id}}" ng-model="itembox"
                        (change)="selectedBranchoffice(item)">
                      <label class="custom-control-label p-t-3" for="branch_{{item.id}}">{{item.description}}</label>
                    </div>
                  </div>
                </ng-container>

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <p class="text-center p-t-15">
            <ng-container *ngIf="item.value.url_image != null">
              <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
            </ng-container>
            <ng-container *ngIf="item.value.url_image == null">
              <ng-container *ngIf="imageUrl == null">
                <img id="output" width="200" src="/images/default.png" />
              </ng-container>
              <ng-container *ngIf="imageUrl != null">
                <img width="200" height="165" [src]="imageUrl" alt="Preview">
              </ng-container>
            </ng-container>
          </p>
          <p class="text-center">
            <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
              Seleccionar Imagen
              <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                style="visibility: hidden;">
            </label>
          </p>
        </div>
        <div class="form-group col-lg-12 form__footerBtn">
          <div class="text-right">
            <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
            <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
              <i class="far fa-save m-r-5"></i>
              <ng-container *ngIf="!isEdit">
                Guardar
              </ng-container>
              <ng-container *ngIf="isEdit">
                Guardar Cambios
              </ng-container>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
